module.exports = __webpack_public_path__ + "img/chaseBride.3613a151.gif";